const getIntegrations = () => {
  return { Drift: true, Intercom: false, Appcues: false };
};

export default getIntegrations;
